import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

const servicesData = {
  'koruklu-tente': {
    name: 'Körüklü Tente',
    image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/cabfb2b171a0f02fec5e186c7450ff16.png',
    description: [
      'Körüklü tente sistemleri, Bursa\'da konut ve ticari alanlarda en çok tercih edilen gölgelendirme çözümlerinden biridir. Esnek kol mekanizması sayesinde kolayca açılıp kapanabilen körüklü tenteler, balkon, teras ve bahçe alanlarınızı güneşin zararlı etkilerinden korur.',
      'Modern alüminyum kol sistemi ile donatılmış körüklü tentelerimiz, uzun ömürlü kullanım garantisi sunar. Dayanıklı kumaş seçenekleri ile hem estetik hem de fonksiyonel bir çözüm sağlar.',
      'Manuel veya motorlu seçenekleriyle ihtiyacınıza göre özelleştirilebilen körüklü tente sistemleri, rüzgar sensörü ve uzaktan kumanda gibi akıllı özelliklerle de sunulabilir.',
    ],
    advantages: [
      'Esnek ve dayanıklı kol mekanizması',
      'Kolay açılıp kapanma sistemi',
      'Manuel veya motorlu seçenekler',
      'UV korumalı kumaş seçenekleri',
      'Geniş renk ve desen çeşitliliği',
      'Uzun ömürlü alüminyum konstrüksiyon',
      'Hava şartlarına dayanıklı',
      'Profesyonel montaj garantisi',
    ],
  },
  'mafsalli-tente': {
    name: 'Mafsallı Tente',
    image: 'https://public.readdy.ai/ai/img_res/cc151d359b1958a3464368ca6389db41.jpg',
    description: [
      'Mafsallı tente sistemleri, klasik tente modellerinin en şık ve estetik olanıdır. Bursa\'da özellikle dükkan, cafe ve restoranların vazgeçilmezi olan mafsallı tenteler, işletmenize nostaljik ve zarif bir görünüm kazandırır.',
      'Geleneksel mafsal mekanizması ile çalışan bu tente türü, sağlam metal konstrüksiyonu sayesinde uzun yıllar sorunsuz hizmet verir. Çizgili veya düz renk kumaş seçenekleri ile markanızın kimliğine uygun tasarımlar oluşturulabilir.',
      'Manuel açılıp kapanma özelliğine sahip mafsallı tenteler, özellikle vitrin ve pencere üzerinde kullanıldığında hem gölgelendirme hem de dekoratif bir unsur olarak öne çıkar.',
    ],
    advantages: [
      'Klasik ve zarif tasarım',
      'Güçlü metal mafsal sistemi',
      'İşletmelere özel tasarım',
      'Çizgili ve düz renk kumaş seçenekleri',
      'Vitrin ve pencere uygulamaları',
      'Dayanıklı konstrüksiyon',
      'Kolay bakım ve temizlik',
      'Marka kimliğine uygun özelleştirme',
    ],
  },
  'otomatik-pergola': {
    name: 'Otomatik Pergola',
    image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/ff193db8c6ee32d0b64162a4491bed92.png',
    description: [
      'Otomatik pergola sistemleri, modern teknoloji ile konforun buluştuğu akıllı gölgelendirme çözümleridir. Bursa\'da konut ve ticari alanlarda giderek yaygınlaşan otomatik pergolalar, uzaktan kumanda ile tek tuşla kontrol edilebilir.',
      'Elektrikli motor sistemi sayesinde açılıp kapanan tavan panelleri, hava şartlarına göre anında ayarlanabilir. Rüzgar ve yağmur sensörleri ile donatılmış modeller, olumsuz hava koşullarında otomatik olarak kapanarak sistemi korur.',
      'Alüminyum konstrüksiyonlu otomatik pergolalar, dayanıklılığı ve şık görünümü ile yaşam alanlarınıza değer katar. LED aydınlatma, ısıtma ve ses sistemi entegrasyonu gibi ek özelliklerle tam bir outdoor yaşam deneyimi sunar.',
    ],
    advantages: [
      'Uzaktan kumanda ile kolay kontrol',
      'Elektrikli motor sistemi',
      'Rüzgar ve yağmur sensörü opsiyonları',
      'LED aydınlatma entegrasyonu',
      'Dayanıklı alüminyum yapı',
      'Akıllı ev sistemleri ile uyumlu',
      'Su geçirmez tavan panelleri',
      'Minimal bakım gereksinimi',
    ],
  },
  'bioklimatik-pergola': {
    name: 'Bioklimatik Pergola',
    image: 'https://readdy.ai/api/search-image?query=Modern%20bioclimatic%20pergola%20system%20installed%20in%20a%20luxury%20outdoor%20living%20space%20with%20motorized%20rotating%20louvers%20providing%20adjustable%20shade%20control%2C%20featuring%20sleek%20aluminum%20frame%20in%20anthracite%20gray%20finish%2C%20integrated%20LED%20lighting%20strips%2C%20clean%20minimalist%20design%2C%20contemporary%20architectural%20style%2C%20simple%20light%20neutral%20background%20emphasizing%20the%20structure&width=1200&height=800&seq=biodet1&orientation=landscape',
    description: [
      'Bioklimatik pergola sistemleri, outdoor yaşam alanlarının en lüks ve teknolojik çözümüdür. Bursa\'da özellikle villa ve üst segment konutlarda tercih edilen bioklimatik pergolalar, döner lamel sistemi ile hava akışını ve ışık miktarını tam olarak kontrol etmenizi sağlar.',
      'Motorize lamel sistemli tavanı, 0 ile 135 derece arasında ayarlanabilen lameller sayesinde dilediğiniz kadar güneş ışığı ve hava akışı sağlar. Yağmurlu havalarda lamellar tamamen kapatılarak su geçirmez bir çatı oluşturur.',
      'LED aydınlatma, ısıtma panelleri, cam kaydırma sistemleri ve akıllı kontrol özellikleri ile bioklimatik pergolalar, bahçenizi yılın her mevsimi kullanabileceğiniz konforlu bir yaşam alanına dönüştürür.',
    ],
    advantages: [
      'Ayarlanabilir lamel sistemi (0-135°)',
      'Tam hava akışı kontrolü',
      'Su geçirmez kapalı pozisyon',
      'Motorize ve sensörlü sistem',
      'LED aydınlatma entegrasyonu',
      'Yan cam kaydırma panelleri opsiyonu',
      'Isıtıcı ve ses sistemi uyumlu',
      '4 mevsim kullanım imkanı',
    ],
  },
  'zip-perde': {
    name: 'Zip Perde',
    image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/48ac3939e61f0dbaa2b1b53cc30358d6.jpeg',
    description: [
      'Zip perde sistemleri, yan yönlendirme raylı özel dikey gölgelendirme çözümüdür. Bursa\'da balkon, teras ve pergola alanlarında sıklıkla kullanılan zip perdeler, rüzgara karşı maksimum dayanıklılık sunar.',
      'Kumaşın yan kenarlarının alüminyum raylara kilitlenmesi sayesinde güçlü rüzgarlarda bile sabit kalır ve sallanmaz. Bu özellik sayesinde yüksek katlardaki balkonlar ve açık alanlarda ideal bir çözümdür.',
      'Şeffaf, yarı şeffaf veya opak kumaş seçenekleri ile hem manzaranızı korur hem de güneş ve yağmurdan maksimum koruma sağlarsınız. Manuel veya motorlu sistemlerle kolayca kullanılabilir.',
    ],
    advantages: [
      'Yan raylar ile rüzgar geçirmez',
      'Güçlü rüzgarlarda sabit kalır',
      'Şeffaf, yarı şeffaf ve opak kumaş',
      'Manzara korumalı gölgelendirme',
      'Manuel veya motorlu seçenekler',
      'Yüksek katlarda ideal kullanım',
      'Su geçirmez kumaş seçenekleri',
      'Uzun ömürlü alüminyum ray sistemi',
    ],
  },
  'seffaf-stor': {
    name: 'Şeffaf Stor',
    image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/037fad47e2fe181b92aebf396e0acb20.webp',
    description: [
      'Şeffaf stor sistemleri, manzaranızı kapatmadan rüzgar, yağmur ve soğuktan korunmanızı sağlayan yenilikçi bir çözümdür. Bursa\'da cafe, restoran ve konut balkonlarında yaygın olarak kullanılan şeffaf storlar, açık alanlarınızı kış aylarında da kullanılabilir hale getirir.',
      'Kristal berraklığındaki PVC malzemesi sayesinde dışarıyı net bir şekilde görmeye devam ederken, hava şartlarından tam koruma sağlarsınız. Bu özellik sayesiyle balkon ve teraslarınız neredeyse bir kış bahçesine dönüşür.',
      'Dikey veya yatay kullanım seçenekleri ile esnek montaj imkanı sunar. Manuel veya motorlu sistemlerle kolayca açılıp kapanabilir, ihtiyaç duyduğunuzda tamamen yukarı kaldırılabilir.',
    ],
    advantages: [
      'Kristal berraklığında şeffaf malzeme',
      'Manzarayı koruyarak hava perdesi',
      'Rüzgar, yağmur ve soğuk koruması',
      'Kış bahçesi etkisi yaratır',
      'Dikey veya yatay kullanım',
      'Manuel veya motorlu sistem',
      'Cafe ve restoranlar için ideal',
      'Kolay temizlik ve bakım',
    ],
  },
  'fransiz-tente': {
    name: 'Fransız Tente',
    image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/38c3491ffaccb66b24e7c806b18477ec.png',
    description: [
      'Fransız tente sistemleri, klasik Avrupa estetiğini işletmenize taşıyan dekoratif gölgelendirme çözümleridir. Bursa\'da özellikle cafe, restoran ve butik dükkanların vazgeçilmezi olan Fransız tenteler, nostaljik ve romantik bir atmosfer yaratır.',
      'Kavisli çerçeve yapısı ve genellikle çizgili kumaş desenleri ile karakteristik görünüme sahip olan Fransız tenteler, işletmenizin dış cephesine Parisi bir hava katar. Vitrin ve giriş kapıları üzerinde kullanıldığında hem işlevsel hem de estetik bir unsur olarak öne çıkar.',
      'Sabit veya hareketli kol seçenekleri ile sunulan Fransız tenteler, markanızın kimliğine uygun özel renk ve desen kombinasyonları ile üretilebilir.',
    ],
    advantages: [
      'Klasik Avrupa estetiği',
      'Kavisli zarif tasarım',
      'Çizgili ve renkli kumaş seçenekleri',
      'Cafe ve restoran cepheleri için ideal',
      'Nostaljik ve romantik atmosfer',
      'Marka kimliğine özel tasarım',
      'Sabit veya hareketli kol sistemi',
      'Vitrin ve kapı üstü uygulamaları',
    ],
  },
  'kasetli-tente': {
    name: 'Kasetli Tente',
    image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/9c05db707225360dbe425359092559a4.png',
    description: [
      'Kasetli tente sistemleri, kumaş ve mekanizmayı tam olarak koruyan kapalı kasa tasarımı ile tente sistemlerinin en gelişmiş modelidir. Bursa\'da modern mimari yapılarda tercih edilen kasetli tenteler, şık görünümü ve uzun ömürlü yapısı ile öne çıkar.',
      'Tente kapalıyken kumaş ve kol sistemi tamamen alüminyum kasa içinde korunur. Bu sayede hava şartlarından, kirden ve nemden etkilenmez, kumaşın ömrü önemli ölçüde uzar. Minimalist kasa tasarımı, modern bina cephelerine mükemmel uyum sağlar.',
      'Genellikle motorlu sistem ile sunulan kasetli tenteler, uzaktan kumanda, rüzgar sensörü ve güneş sensörü gibi akıllı özelliklerle donatılabilir. LED aydınlatma entegrasyonu ile gece kullanımı da son derece konforludur.',
    ],
    advantages: [
      'Tam kapalı koruma kasası',
      'Kumaş ve mekanizma koruması',
      'Uzun ömürlü ve dayanıklı',
      'Minimalist şık tasarım',
      'Motorlu akıllı sistem',
      'Sensör ve kumanda opsiyonları',
      'LED aydınlatma entegrasyonu',
      'Modern mimariye uygun',
    ],
  },
  'karpuz-tente': {
    name: 'Karpuz Tente',
    image: 'https://readdy.ai/api/search-image?query=Dome%20shaped%20watermelon%20style%20awning%20with%20curved%20semicircular%20design%2C%20striped%20colorful%20fabric%20pattern%2C%20traditional%20commercial%20storefront%20installation%2C%20rounded%20protective%20canopy%2C%20classic%20Mediterranean%20style%2C%20simple%20background%20showcasing%20the%20curved%20awning%20shape&width=1200&height=800&seq=kardet1&orientation=landscape',
    description: [
      'Karpuz tente sistemleri, kubbe şeklindeki karakteristik tasarımı ile geleneksel Türk tente modellerinin en bilinenidir. Bursa\'da özellikle pazar yerleri, dükkan girişleri ve küçük ticari alanlarda yaygın olarak kullanılan karpuz tenteler, nostaljik ve samimi bir atmosfer yaratır.',
      'Yarım daire şeklindeki çerçeve sistemi ve genellikle çizgili renkli kumaş seçenekleri ile dikkat çeken karpuz tenteler, hem güneşten hem de hafif yağmurdan koruma sağlar. Özellikle giriş kapıları ve vitrinler üzerinde kullanıldığında davetkar bir görünüm oluşturur.',
      'Ekonomik ve pratik bir çözüm olan karpuz tenteler, kolay montaj ve bakım özellikleri ile küçük işletmeler için idealdir. Çeşitli boyut ve renk seçenekleri ile her türlü iş yerine uygun üretim yapılabilir.',
    ],
    advantages: [
      'Geleneksel kubbe tasarımı',
      'Nostaljik ve samimi görünüm',
      'Ekonomik ve pratik çözüm',
      'Çizgili renkli kumaş seçenekleri',
      'Giriş kapıları için ideal',
      'Kolay montaj ve bakım',
      'Pazar ve dükkanlar için uygun',
      'Çeşitli boyut seçenekleri',
    ],
  },
  't-modul-tente': {
    name: 'T Modül Tente',
    image: 'https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/9afa341389428a0904540c32aed58d2e.png',
    description: [
      'T Modül tente sistemleri, yenilikçi modüler yapısı ve çağdaş tasarımı ile modern mimarinin vazgeçilmez gölgelendirme çözümlerindendir. Bursa\'da ticari kompleksler, alışveriş merkezleri ve geniş açık alanlarda tercih edilen T Modül tenteler, esnek ve genişletilebilir yapısı ile her ölçekte proje için uygundur.',
      'T şeklindeki taşıyıcı sistem sayesinde ara destek kolonlarına gerek kalmadan geniş açıklıklar kapatılabilir. Modüler yapısı, ihtiyaca göre yan yana veya arka arkaya ekleme yapılarak alanın genişletilmesine olanak tanır. Bu özellik özellikle büyük ticari projelerde büyük avantaj sağlar.',
      'Dayanıklı alüminyum konstrüksiyon ve yüksek kaliteli gergi kumaşları ile uzun ömürlü kullanım garantisi sunar. Minimal bakım gereksinimi ve modern estetik görünümü ile T Modül tenteler, mimari projelere değer katan bir gölgelendirme sistemidir. Sabit veya hareketli tavan seçenekleri, LED aydınlatma ve yağmur sensörü gibi akıllı özelliklerle de donatılabilir.',
    ],
    advantages: [
      'Modüler ve genişletilebilir yapı',
      'Geniş açıklıkları ara destek olmadan kapatır',
      'Modern ve minimalist tasarım',
      'Ticari projeler için ideal',
      'Dayanıklı alüminyum konstrüksiyon',
      'Sabit veya hareketli tavan seçenekleri',
      'LED aydınlatma entegrasyonu',
      'Minimal bakım gereksinimi',
    ],
  },
};

export default function ServiceDetail() {
  const { slug } = useParams<{ slug: string }>();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  const openLightbox = (imageSrc: string) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
  };

  const service = slug ? servicesData[slug as keyof typeof servicesData] : null;

  if (!service) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-primary mb-4">Hizmet Bulunamadı</h2>
          <Link to="/hizmetler" className="text-secondary hover:underline cursor-pointer">
            Hizmetler sayfasına dön
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-32 pb-20">
        <div className="max-w-[1200px] mx-auto px-6">
          <article>
            <header className="mb-8">
              <nav className="text-sm text-gray-600 mb-4">
                <Link to="/" className="hover:text-secondary cursor-pointer">
                  Anasayfa
                </Link>
                {' / '}
                <Link to="/hizmetler" className="hover:text-secondary cursor-pointer">
                  Hizmetler
                </Link>
                {' / '}
                <span className="text-primary font-semibold">{service.name}</span>
              </nav>
              <h1 className="text-5xl font-bold text-primary mb-4">Bursa {service.name} Sistemleri</h1>
            </header>

            {/* Single Main Image */}
            <div className="mb-12">
              <div className="relative rounded-2xl overflow-hidden shadow-lg h-96 cursor-pointer" onClick={() => openLightbox(service.image)}>
                <img
                  src={service.image}
                  alt={`Bursa ${service.name} Ana Görsel`}
                  className="w-full h-full object-cover"
                  loading="eager"
                />
              </div>
            </div>

            <div className="grid lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2 space-y-6">
                {service.description.map((paragraph, index) => (
                  <p key={index} className="text-gray-700 leading-relaxed text-lg">
                    {paragraph}
                  </p>
                ))}

                <section className="mt-12">
                  <h2 className="text-3xl font-bold text-primary mb-6">Avantajlar</h2>
                  <ul className="grid md:grid-cols-2 gap-4">
                    {service.advantages.map((advantage, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-secondary text-xl mt-0.5"></i>
                        <span className="text-gray-700">{advantage}</span>
                      </li>
                    ))}
                  </ul>
                </section>
              </div>

              <aside className="lg:col-span-1">
                <div className="sticky top-24 space-y-6">
                  <div className="bg-primary text-white rounded-2xl p-8">
                    <h3 className="text-2xl font-bold mb-4">Hemen Teklif Alın</h3>
                    <p className="text-gray-200 mb-6">
                      {service.name} sistemlerimiz hakkında detaylı bilgi ve fiyat teklifi için bize ulaşın.
                    </p>
                    <a
                      href={`https://wa.me/905421821925?text=Merhaba,%20${service.name}%20hakkında%20bilgi%20almak%20istiyorum`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block w-full bg-white text-primary text-center px-6 py-3 rounded-full font-bold hover:bg-gray-100 transition-all mb-3 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-fill mr-2"></i>
                      WhatsApp ile İletişim
                    </a>
                    <a
                      href="tel:+905421821925"
                      className="block w-full border-2 border-white text-white text-center px-6 py-3 rounded-full font-bold hover:bg-white hover:text-primary transition-all cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-phone-fill mr-2"></i>
                      Hemen Ara
                    </a>
                  </div>

                  <div className="bg-gray-50 rounded-2xl p-6">
                    <h4 className="text-xl font-bold text-primary mb-4">Diğer Hizmetler</h4>
                    <ul className="space-y-3">
                      {Object.entries(servicesData)
                        .filter(([key]) => key !== slug)
                        .slice(0, 4)
                        .map(([key, data]) => (
                          <li key={key}>
                            <Link
                              to={`/hizmetler/${key}`}
                              className="text-gray-700 hover:text-secondary transition-colors flex items-center gap-2 cursor-pointer"
                            >
                              <i className="ri-arrow-right-s-line text-secondary"></i>
                              {data.name}
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
          </article>
        </div>
      </main>

      <Footer />
      <CookieBanner />

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 cursor-pointer"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors"
            onClick={closeLightbox}
            aria-label="Kapat"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Büyütülmüş görsel"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
